'use strict';

/**
 *
 * @name: apiTagService
 *
 */

function apiTagService(
  $http,
  $rootScope,
  transObject
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function currentUserTags(options) {

    var target = $rootScope.apiUrlNew + '/tag?' +
      (typeof options.isSubscribed !== 'undefined' ? '&isSubscribed=' + options.isSubscribed : '');

    return $http.get(target);
  }

  function getBySlug(slug) {

    var target = $rootScope.apiUrlNew + '/tag/getbyslug/' + slug;

    return $http
      .get(target)
      .then(function(res) {

        transObject.translate(res.data);
        return res;
      });
  }

  function getList(options) {

    var target = $rootScope.apiUrlNew + '/tag?' +
      (angular.isDefined(options.isSubscribed) ? '&isSubscribed=' + options.isSubscribed : '') +
      (options.page ? '&page=' + options.page : '') +
      (options.limit ? '&limit=' + options.limit : '') +
      (options.order ? '&order=' + options.order : '') +
      (options.textLike ? '&textLike=' + options.textLike : '') +
      (options.language ? '&language=' + options.language : '') +
      (angular.isDefined(options.notTranslated) ? '&notTranslated=' + options.notTranslated : '');

    return $http
      .get(target)
      .success(function(data) {

        transObject.translate(data);
      });
  }

  function search(options) {

    var target = $rootScope.apiUrlNew + '/tag/list/search?' +
      (options.page ? '&page=' + options.page : '') +
      (options.limit ? '&limit=' + options.limit : '') +
      (options.order ? '&order=' + options.order : '') +
      (options.hasThumbnail ? '&hasThumbnail=' + options.hasThumbnail : '') +
      (options.text ? '&search=' + options.text : '');

    return $http.get(target);
  }

  function viewTag(tagId) {

    var target = $rootScope.apiUrlNew + '/tag/' + tagId + '/view';

    return $http.post(target);
  }

  function subscribe(id) {

    var target = $rootScope.apiUrlNew + '/tag/' + id + '/subscribe';

    return $http.post(target);
  }

  function unsubscribe(id) {

    var target = $rootScope.apiUrlNew + '/tag/' + id + '/unsubscribe';

    return $http.post(target);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    getBySlug: getBySlug,
    getList: getList,
    currentUserTags: currentUserTags,
    search: search,
    viewTag: viewTag,
    subscribe: subscribe,
    unsubscribe: unsubscribe,
  };
}

export default apiTagService;



// WEBPACK FOOTER //
// ./app/components/_api/tag.service.js